import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'
import type { CarePlanConditionGroupsResponse } from '@/types/interfaces/carePlanConditionGroups'

export const carePlanConditionGroupsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCarePlanConditionGroups: builder.query<CarePlanConditionGroupsResponse, void>({
            query: () => apiEndpoints.carePlans.getConditionGroups,
            providesTags: ['CarePlanConditionGroups'],
        }),
    }),
    overrideExisting: false,
})

export const { useGetCarePlanConditionGroupsQuery } = carePlanConditionGroupsApi
